import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/outbox/')({
    head: () => ({
        meta: [
            {
                title: 'Outbox | Phoebe Admin',
            },
        ],
    }),
});
